import "../Styling/App.css";
import { useState } from "react";
import Quiz from "../components/Form/Quiz";
import FeedbackScreen from "components/Form/FeebackScreen";
import { GameStateContext } from "../assets/Helpers/gameContexts";
import formJson from "../assets/forms/forms.json";
import SurveyDashboard from "../components/Form/SurveyDashboard";

function Forms() {
  const [gameState, setGameState] = useState("menu");
  const [userName, setUserName] = useState("");
  const [score, setScore] = useState(0);

  return (
    <div className="App">
      <GameStateContext.Provider
        value={{
          gameState,
          setGameState,
          userName,
          setUserName,
          score,
          setScore,
        }}
      >
        {gameState === "menu" && <SurveyDashboard />}
        {gameState === "playing" && <Quiz form={formJson} />}
        {gameState === "finished" && <FeedbackScreen />}
      </GameStateContext.Provider>
    </div>
  );
}

export default Forms;
